import type { HelpZettel } from '@/types/help'
import type { TalkOfflineItem } from './talkOffline'

export function offlineToZettel(item: TalkOfflineItem, conversationId: string, senderRole: string): HelpZettel {
  const createdAt = item.createdAt || new Date().toISOString()
  const preview = item.preview || item.text || ''
  return {
    id: `offline:${item.id}`,
    conversation_id: conversationId,
    status: 'wartet',
    sender_role: senderRole,
    last_activity_at: createdAt,
    done_at: null,
    user_hidden_at: null,
    opener_preview: preview,
    opener_id: item.clientId || item.id,
    opener_created_at: createdAt,
    transcript_pending: Boolean(item.blob),
    has_audio: Boolean(item.blob),
    audio_duration_ms: item.durationMs ?? null,
  }
}

export function mergeOfflineZettel(server: HelpZettel[], queue: TalkOfflineItem[], conversationId: string, senderRole: string): HelpZettel[] {
  const extra = queue
    .filter(q => !q.conversationId || q.conversationId === conversationId)
    .map(q => offlineToZettel(q, conversationId, senderRole))
  return [...extra, ...server]
}

export function isOfflineZettelId(id: string): boolean {
  return id.startsWith('offline:')
}
